module.exports = __webpack_public_path__ + "img/26_31.a0d928cf.png";